import { createSlice } from "@reduxjs/toolkit";
import {
  addCancelBooking,
  bookingCancel,
} from "./services/bookingcancellation.services";

const initialState = {
  loading: false,
  error: "",
};

const bookingcancellation = createSlice({
  name: "bookingcancellation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(bookingCancel.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(bookingCancel.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(bookingCancel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(addCancelBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(addCancelBooking.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(addCancelBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default bookingcancellation.reducer;
